import { useMutation, useQuery } from "@tanstack/react-query";
import { Button, Divider, Form, Input, message } from "antd";
import { useState } from "react";
import {
  AddDayOffType,
  deleteDayOffType,
  getDayOffTypes,
} from "../../network/workingHours";
import SalonLocationsSelect from "../../components/common/SalonLocationsSelect";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import { getLocations } from "../../network/settings";

type Props = {};

const TeamMemberVacations = (props: Props) => {
  const intl = useIntl();
  const [inputValue, setInputValue] = useState<any>("");
  const [valuesArray, setValuesArray] = useState<any>([]);
  const { data, refetch } = useQuery(["vacationTypes"], getDayOffTypes);
  const { locationId } = useSelector((state: any) => state.calendar);
  const { mutate, isLoading } = useMutation(
    (val) => AddDayOffType(val, locationId),
    { onSuccess: () => refetch() }
  );
  const { data: locations } = useQuery(["location"], () => getLocations());

  // const { mutate: deleteVactionType, isLoading: deleteLoading } = useMutation(
  //   (vactionId) => deleteVactionType(vactionId, locationId),
  //   { onSuccess: () => refetch() }
  // );
  const { mutate: deleteMutate, isLoading: deleteLoading } = useMutation(
    (vactionId: number) => deleteDayOffType(vactionId, locationId),
    {
      onSuccess: () => {
        message.success("تم حذف النوع بنجاح");
        refetch();
      },
    }
  );
  const onFinish = (values: any) => {};
  // const handlePressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
  //   e.preventDefault();

  //   if (inputValue.trim() !== "") {
  //     const newType = {
  //       id: Date.now(),
  //       name: inputValue.trim(),
  //     };

  //     setValuesArray((prevTypes: any) => [...prevTypes, newType]);

  //     setInputValue("");
  //   }
  // };
  const handleDeleteType = (id: number) => {
    if (!id) {
      return false;
    }
    if (deleteLoading) {
      return false;
    }
    deleteMutate(id);
    setValuesArray((prevTypes: any) =>
      prevTypes.filter((type: any) => type.id !== id)
    );
  };
  const handleAdd = () => {
    if (!inputValue) {
      return false;
    }
    mutate(inputValue);
  };
  return (
    <div>
      <div className="my-2">
        <SalonLocationsSelect />
      </div>
      <div className="text-color-primary text-2xl font-semibold leading-7 flex items-center gap-2 text-end">
        <FormattedMessage id="typesOfSalonHolidays" />
      </div>
      <div className="my-4 text-color-gray text-base font-normal leading-7 ">
        <FormattedMessage id="defineAvailableHolidays" />
      </div>
      <div>
        <Form
          name="commissions"
          onFinish={onFinish}
          // layout="vertical"
          className=""
          dir="rtl"
        >
          <div className="w-full flex flex-col py-6 px-4 gap-4 items-center justify-center mt-1 bg-[#EEF0FF] rounded-lg">
            <div className="bg-white rounded-lg p-4 w-full">
              <h5 className=" text-color-primary px-2 py-1 bg-[#EEF0FF] w-fit rounded-lg  font-normal text-sm">
                <FormattedMessage id="salonHolidaysTitle" />
              </h5>
              <h5 className=" font-normal text-sm text-black mt-3">
                <span className="text-[#75757E]">الفروع</span> :
                {locations?.data?.map((e: any) => (
                  <span>{e?.name}</span>
                ))}{" "}
              </h5>
              <Divider className="my-2" />
              <div className="w-full p-4 m-2 ">
                <Input
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  // onPressEnter={handlePressEnter}
                  placeholder={intl.formatMessage({
                    id: "addAnotherTypePlaceholder",
                  })}
                  className="w-[300px] mx-2 "
                />
                <Button
                  type="primary"
                  htmlType="button"
                  loading={isLoading}
                  onClick={handleAdd}
                >
                  {intl.formatMessage({
                    id: "add",
                    defaultMessage: "إضافة",
                  })}
                </Button>
              </div>
              <div className="flex flex-wrap gap-2 ">
                {/* {oldData?.map((e) => (
                  <Button className="bg-[#CFCFE2] text-[#75757E] py-3 px-4 h-full">
                    {e}
                  </Button>
                ))} */}

                {data?.data?.map(
                  (e: {
                    id: number;
                    reason: string;
                    salon_id: number;
                    static: boolean;
                  }) =>
                    e?.static ? (
                      <Button className="bg-[#CFCFE2]  text-[#75757E] py-3 px-4 h-full">
                        {e?.reason}
                      </Button>
                    ) : (
                      <div className="flex bg-[#EEF0FF] px-3 py-2 items-center rounded-lg gap-1">
                        <span className="me-2">{e.reason}</span>

                        <Button key={e.id} type="text" className=" ">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            onClick={() => handleDeleteType(e.id)}
                            className="cursor-pointer"
                          >
                            <path
                              d="M6.66536 1.50012C6.38922 1.50012 6.16536 1.72398 6.16536 2.00012V2.50012H3.33203C3.05589 2.50012 2.83203 2.72398 2.83203 3.00012C2.83203 3.27626 3.05589 3.50012 3.33203 3.50012H12.6654C12.9415 3.50012 13.1654 3.27626 13.1654 3.00012C13.1654 2.72398 12.9415 2.50012 12.6654 2.50012H9.83203V2.00012C9.83203 1.72398 9.60817 1.50012 9.33203 1.50012H6.66536Z"
                              fill="#C43535"
                            />
                            <path
                              d="M8.70581 10.0001L9.68558 10.9799C9.88085 11.1752 9.88085 11.4917 9.68558 11.687C9.49032 11.8823 9.17374 11.8823 8.97848 11.687L7.9987 10.7072L7.01892 11.687C6.82366 11.8823 6.50708 11.8823 6.31182 11.687C6.11655 11.4917 6.11655 11.1752 6.31182 10.9799L7.2916 10.0001L6.31181 9.02034C6.11655 8.82507 6.11655 8.50849 6.31181 8.31323C6.50707 8.11797 6.82366 8.11797 7.01892 8.31323L7.9987 9.29301L8.97848 8.31323C9.17375 8.11797 9.49033 8.11797 9.68559 8.31324C9.88085 8.5085 9.88085 8.82508 9.68559 9.02034L8.70581 10.0001Z"
                              fill="#C43535"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M3.99298 5.27824C4.02112 5.02502 4.23515 4.83346 4.48992 4.83346H11.5075C11.7622 4.83346 11.9763 5.02502 12.0044 5.27824L12.1378 6.47914C12.3797 8.65602 12.3797 10.853 12.1378 13.0299L12.1247 13.1481C12.0287 14.0122 11.359 14.7012 10.498 14.8218C8.83987 15.0539 7.15752 15.0539 5.49942 14.8218C4.63839 14.7012 3.9687 14.0122 3.87268 13.1481L3.85955 13.0299C3.61767 10.853 3.61767 8.65602 3.85955 6.47914L3.99298 5.27824ZM4.93744 5.83346L4.85343 6.58957C4.61971 8.69305 4.61971 10.816 4.85343 12.9194L4.86657 13.0377C4.9121 13.4475 5.22971 13.7743 5.63806 13.8314C7.20418 14.0507 8.79321 14.0507 10.3593 13.8314C10.7677 13.7743 11.0853 13.4475 11.1308 13.0377L11.144 12.9194C11.3777 10.816 11.3777 8.69306 11.144 6.58957L11.0599 5.83346H4.93744Z"
                              fill="#C43535"
                            />
                          </svg>
                        </Button>
                      </div>
                    )
                )}
              </div>
            </div>
          </div>
          {/* <div className="flex items-center justify-end gap-4 w-full my-6">
            <Button
              type="primary"
              className="bg-color-primary h-full text-white text-lg rounded-md px-2 w-fit min-w-[200px]"
              htmlType="submit"
            >
              حفظ التغييرات
            </Button>
            <Button
              type="primary"
              // onClick={() => close()}
              className="bg-color-light h-full border-[#FBFBFF] text-black text-lg rounded-md px-2 w-fit min-w-[200px]"
              htmlType="button"
            >
              الغاء
            </Button>
          </div> */}
        </Form>
      </div>
    </div>
  );
};

export default TeamMemberVacations;
